document.addEventListener( 'DOMContentLoaded', function () {
	const pollOptions = document.querySelectorAll( '.poll-option-button' );
	const pollModules = document.querySelectorAll( '.poll-module' );

	// Function to handle featured media display
	function initializeFeaturedMedia() {
		const featuredMedia = document.querySelectorAll( '.poll-featured-media' );

		featuredMedia.forEach( media => {
			const video = media.querySelector( '.youtube-embed iframe' );
			if ( video ) {
				// Add loading state for videos
				video.addEventListener( 'load', function () {
					this.style.opacity = '1';
				} );

				// Add error handling for videos
				video.addEventListener( 'error', function () {
					const errorDiv = document.createElement( 'div' );
					errorDiv.className = 'video-error';
					errorDiv.innerHTML = '<p>Failed to load video. Please check the URL.</p>';
					media.appendChild( errorDiv );
				} );
			}
		} );
	}

	// Initialize featured media on page load
	initializeFeaturedMedia();

	// Function to apply color scheme based on single/multi color toggle
	function applyColorScheme() {
		pollModules.forEach( module => {
			const isSingleColor = module.classList.contains( 'single-color' );
			const options = module.querySelectorAll( '.poll-option' );

			if ( isSingleColor ) {
				// Apply single color scheme
				options.forEach( option => {
					option.classList.remove( 'multi-color-option' );
					option.classList.add( 'single-color-option' );
				} );
			} else {
				// Apply multi color scheme
				options.forEach( ( option, index ) => {
					option.classList.remove( 'single-color-option' );
					option.classList.add( 'multi-color-option' );
					option.classList.add( `color-${ index % 5 }` ); // 5 different colors
				} );
			}
		} );
	}
	// Apply color scheme on page load
	applyColorScheme();

	// Function to fetch poll results from server
	// async function fetchPollResults( pollId, pollModule ) {
	// 	const formData = new FormData();
	// 	formData.append( 'action', 'get_poll_results' );
	// 	formData.append( 'poll_id', pollId );
	// 	if ( typeof ajax_object !== 'undefined' && ajax_object.nonce ) {
	// 		formData.append( 'nonce', ajax_object.nonce );
	// 	}

	// 	fetch( window.pollAjaxData?.ajaxurl || window.ajaxurl || '/wp-admin/admin-ajax.php', {
	// 		method: 'POST',
	// 		body: formData,
	// 		credentials: 'same-origin', // Add this to ensure cookies are sent
	// 	} )
	// 		.then( response => {
	// 			if ( ! response.ok ) {
	// 				throw new Error( 'Network response was not ok' );
	// 			}
	// 			return response.json();
	// 		} )
	// 		.then( data => {
	// 			if ( data.success && data.data ) {
	// 				updatePollResults( pollModule, data.data );
	// 			} else {
	// 				throw new Error( data.data?.message || 'Failed to fetch poll results' );
	// 			}
	// 		} )
	// 		.catch( error => {
	// 			console.error( 'Error fetching poll results:', error );
	// 			const errorMessage = document.createElement( 'div' );
	// 			errorMessage.className = 'poll-error poll-message';
	// 			errorMessage.innerHTML =
	// 				'<p>Error loading poll results. Please refresh the page.</p>';
	// 			pollModule.appendChild( errorMessage );
	// 		} );
	// }

	// Simple voting restriction using localStorage
	function hasUserVotedOnPoll( pollId ) {
		try {
			// Check for single vote
			if ( localStorage.getItem( `poll_voted_${ pollId }` ) === 'true' ) {
				return true;
			}
			// Check for multiple votes
			if ( localStorage.getItem( `poll_voted_options_${ pollId }` ) ) {
				const votedOptions = JSON.parse(
					localStorage.getItem( `poll_voted_options_${ pollId }` )
				);
				return votedOptions.length > 0;
			}
			return false;
		} catch ( e ) {
			console.error( 'Could not check localStorage', e );
			return false;
		}
	}

	// Function to update poll results in the UI
	function updatePollResults( pollModule, results ) {
		const options = pollModule.querySelectorAll( '.poll-option' );
		const totalVotes = results.total_votes;
		let highestPercentage = 0;
		let highestOption = null;

		options.forEach( option => {
			const index = option.dataset.index;
			const button = option.querySelector( '.poll-option-button' );
			const voteCount = results.vote_counts[ index ] || 0;
			const percentage = results.percentages[ index ] || 0;

			// Create or update vote count
			let voteCountEl = button.querySelector( '.vote-count' );
			if ( ! voteCountEl ) {
				voteCountEl = document.createElement( 'span' );
				voteCountEl.className = 'vote-count';
				button.appendChild( voteCountEl );
			}
			voteCountEl.textContent = `(${ voteCount } votes)`;

			// Create or update percentage
			let votePercent = button.querySelector( '.vote-percent' );
			if ( ! votePercent ) {
				votePercent = document.createElement( 'span' );
				votePercent.className = 'vote-percent';
				button.appendChild( votePercent );
			}
			votePercent.textContent = `${ percentage }%`;

			// Calculate dynamic positioning for low percentages
			if ( percentage < 10 ) {
				// For low percentages, calculate position based on progress bar width
				const progressBar = button.querySelector( '.vote-progress-bar' );
				let offset = -32; // Default offset

				if ( progressBar && percentage > 0 ) {
					// Calculate the actual width of the colored progress bar
					const buttonWidth = button.offsetWidth;
					const progressWidth = ( percentage / 100 ) * buttonWidth;

					// Ensure minimum spacing of 8px between colored bar and percentage text
					const minSpacing = 8;
					offset = -( buttonWidth - progressWidth - minSpacing );

					// Ensure offset doesn't go too far left (minimum -40px)
					offset = Math.max( offset, -40 );
				}

				// Set the dynamic offset using CSS custom property
				button.style.setProperty( '--low-percentage-offset', `${ offset }px` );
				votePercent.classList.add( 'low-percentage' );
				button.classList.add( 'has-low-percentage' );

				// Also set the right position directly for immediate effect
				votePercent.style.right = `${ offset }px`;
				votePercent.style.color = '#ffffff';
				votePercent.style.textShadow = '0 0 2px rgba(0, 0, 0, 0.8)';
			} else if ( percentage === 0 ) {
				// For 0%, position further out with consistent spacing
				votePercent.style.right = '-40px';
				votePercent.style.color = '#ffffff';
				votePercent.style.textShadow = '0 0 2px rgba(0, 0, 0, 0.8)';
				votePercent.classList.add( 'low-percentage' );
				button.classList.add( 'has-low-percentage' );
			} else {
				// For normal percentages, position normally
				votePercent.style.right = '12px';
				votePercent.style.color = '#ffffff';
				votePercent.style.textShadow = 'none';
				votePercent.classList.remove( 'low-percentage' );
				button.classList.remove( 'has-low-percentage' );
			}

			// Create or update progress bar
			let progressBar = button.querySelector( '.vote-progress-bar' );
			if ( ! progressBar ) {
				progressBar = document.createElement( 'div' );
				progressBar.className = 'vote-progress-bar';
				button.appendChild( progressBar );
			}
			// Reset width to 0 first to ensure transition works
			progressBar.style.width = '0%';

			// Use setTimeout to trigger the transition after a brief delay
			setTimeout( () => {
				progressBar.style.width = `${ percentage }%`;
			}, 50 );

			// Track highest percentage
			if ( percentage > highestPercentage ) {
				highestPercentage = percentage;
				highestOption = button;
			}
		} );

		// Highlight the option with highest percentage
		options.forEach( option => {
			const button = option.querySelector( '.poll-option-button' );
			button.classList.remove( 'highest-percentage' );
		} );
		if ( highestOption ) {
			highestOption.classList.add( 'highest-percentage' );
		}

		// Update total votes
		let totalElement = pollModule.querySelector( '.poll-totals' );
		if ( ! totalElement ) {
			totalElement = document.createElement( 'div' );
			totalElement.className = 'poll-totals';
			pollModule.appendChild( totalElement );
		}
		totalElement.innerHTML = `<p>Total votes: ${ totalVotes }</p>`;
	}

	// Function to handle poll responses
	window.storePollResponse = function ( pollId, optionIndex ) {
		if ( ! pollId || optionIndex === undefined ) {
			console.error( 'Invalid poll data:', { pollId, optionIndex } );
			return;
		}

		const pollModule = document.querySelector( `.poll-module[data-poll-id="${ pollId }"]` );
		if ( ! pollModule ) {
			console.error( 'Poll module not found for ID:', pollId );
			return;
		}

		// Check if user has already voted using simple localStorage check
		const hasVoted = hasUserVotedOnPoll( pollId );

		// If user has already voted, show error message
		if ( hasVoted ) {
			// Remove any existing messages
			const existingMessages = pollModule.querySelectorAll( '.poll-message' );
			existingMessages.forEach( msg => msg.remove() );

			const errorMessageDiv = document.createElement( 'div' );
			errorMessageDiv.className = 'poll-message error';
			errorMessageDiv.innerHTML = `
				<div class="error-message">
					<p style="margin: 0;">You have already voted on this poll. You can only vote once.</p>
				</div>`;

			// Insert message after the poll options
			const pollOptions = pollModule.querySelector( '.poll-options' );
			if ( pollOptions ) {
				pollOptions.before( errorMessageDiv );
			}
			return;
		}

		// Check if this is a multiple vote poll
		const isMultipleVote = pollModule.querySelector( '.poll-submit-btn' ) !== null;

		if ( isMultipleVote ) {
			// For multiple vote polls, just toggle selection
			const optionEl = pollModule.querySelector(
				`.poll-option[data-index="${ optionIndex }"]`
			);
			if ( optionEl ) {
				optionEl.classList.toggle( 'selected-option' );

				// Update submit button state
				const submitBtn = pollModule.querySelector( '.submit-vote-btn' );
				const selectedOptions = pollModule.querySelectorAll(
					'.poll-option.selected-option'
				);

				if ( submitBtn ) {
					if ( selectedOptions.length > 0 ) {
						submitBtn.disabled = false;
						submitBtn.textContent = `Submit Vote${
							selectedOptions.length > 1 ? 's' : ''
						} (${ selectedOptions.length })`;
					} else {
						submitBtn.disabled = true;
						submitBtn.textContent = 'Submit Vote';
					}
				}
			}
			return;
		}

		// For single vote polls, proceed with immediate submission
		// Remove any existing messages
		const existingMessages = pollModule.querySelectorAll( '.poll-message' );
		existingMessages.forEach( msg => msg.remove() );

		// Disable the clicked button while submitting
		const clickedButton = pollModule.querySelector( `[data-option-index="${ optionIndex }"]` );
		if ( clickedButton ) {
			clickedButton.disabled = true;
			clickedButton.classList.add( 'voting-in-progress' );
		}

		// Create form data
		const formData = new FormData();
		formData.append( 'action', 'submit_poll_response' );
		formData.append( 'poll_id', pollId );
		formData.append( 'option_index', optionIndex );

		// Use the WordPress AJAX URL
		const ajaxUrl =
			window.pollAjaxData?.ajaxurl || window.ajaxurl || '/wp-admin/admin-ajax.php';

		// Check if user already voted
		const pollVoted = localStorage.getItem( `poll_voted_${ pollId }` );
		if ( pollVoted ) {
			// User already voted, do not allow clicking again
			return;
		}

		// Check if user already voted
		if ( localStorage.getItem( `poll_voted_${ pollId }` ) ) {
			console.log( 'User has already voted.' );
			return; // Stop further voting
		}

		// Disable all poll buttons immediately to prevent multiple clicks
		const pollButtons = pollModule.querySelectorAll( '.poll-option-button' );
		pollButtons.forEach( btn => {
			btn.disabled = true;
			btn.classList.add( 'voting-in-progress' );
		} );

		// Proceed with AJAX request
		jQuery.ajax( {
			url: ajaxUrl,
			type: 'POST',
			data: formData,
			processData: false,
			contentType: false,
			success: function ( response ) {
				const messageDiv = document.createElement( 'div' );
				messageDiv.className = `poll-message ${ response.success ? 'success' : 'error' }`;
				const pollOptions = pollModule.querySelector( '.poll-options' );

				if ( response.success ) {
					const allowMultipleVotes = response.data.allow_multiple_votes;
					const userVotedOptions = response.data.user_voted_options || [];

					if ( ! allowMultipleVotes ) {
						// Single vote: mark poll as voted
						pollModule.classList.add( 'has-voted' );

						try {
							localStorage.setItem( `poll_voted_${ pollId }`, 'true' );
						} catch ( e ) {
							console.error( 'Could not store vote in localStorage', e );
						}

						// Keep all buttons disabled and styled
						pollButtons.forEach( button => {
							button.style.display = 'block';
							button.classList.add( 'voted' );
							button.classList.remove( 'voting-in-progress' );
							if ( pollModule.classList.contains( 'light-background' ) ) {
								button.classList.add( 'light-voted' );
							}
						} );
					} else {
						// Multiple votes: disable only clicked button
						if ( clickedButton ) {
							clickedButton.disabled = true;
							clickedButton.classList.add( 'voted' );
							clickedButton.classList.remove( 'voting-in-progress' );
						}

						try {
							localStorage.setItem(
								`poll_voted_options_${ pollId }`,
								JSON.stringify( userVotedOptions )
							);
						} catch ( e ) {
							console.error( 'Could not store vote in localStorage', e );
						}
					}

					// Show vote results
					if ( response.data.percentages && response.data.vote_counts ) {
						displayVoteResults(
							pollId,
							response.data.percentages,
							response.data.vote_counts,
							response.data.total_votes
						);
					} else {
						loadPollResults( pollId, true );
					}

					// Show thanks message
					const thanksMessageDiv = document.createElement( 'div' );
					thanksMessageDiv.className = 'poll-message success';
					thanksMessageDiv.innerHTML = `
                <div class="success-message">
                    <p style="margin: 0;">Thank you for voting!</p>
                </div>`;
					if ( pollOptions ) pollOptions.before( thanksMessageDiv );

					refreshPollResults( pollId ).catch( console.error );

					// Open Dotdigital modal if available
					const dotdigitalModal = document.getElementById(
						`dotdigital-modal-${ pollId }`
					);
					if ( dotdigitalModal ) {
						setTimeout( () => openDotdigitalModal( pollId ), 3000 );
					}
				} else {
					messageDiv.innerHTML = `
                <div class="error-message">
                    <p style="margin: 0;">${
						response.data?.message || 'Error submitting response. Please try again.'
					}</p>
                </div>`;

					// Re-enable clicked button on error
					if ( clickedButton ) {
						clickedButton.disabled = false;
						clickedButton.classList.remove( 'voting-in-progress' );
					}
				}

				// Insert message
				if ( pollOptions ) pollOptions.before( messageDiv );
			},
			error: function ( xhr, status, error ) {
				console.error( 'AJAX Error:', status, error );
				const messageDiv = document.createElement( 'div' );
				messageDiv.className = 'poll-message error';
				messageDiv.innerHTML = `
            <div class="error-message">
                <p style="margin: 0;">Error submitting response. Please try again.</p>
            </div>`;
				const pollOptions = pollModule.querySelector( '.poll-options' );
				if ( pollOptions ) pollOptions.before( messageDiv );

				if ( clickedButton ) {
					clickedButton.disabled = false;
					clickedButton.classList.remove( 'voting-in-progress' );
				}
			},
		} );
	};

	// Helper function to show error messages
	function showError( pollModule, message ) {
		const errorMessage = document.createElement( 'div' );
		errorMessage.className = 'poll-error poll-message';
		errorMessage.innerHTML = `<p>${ message }</p>`;
		pollModule.appendChild( errorMessage );
	}

	function showResults( pollId, votes, total ) {
		const pollModule = document.querySelector( `.poll-module[data-poll-id="${ pollId }"]` );
		if ( ! pollModule ) return;

		const options = pollModule.querySelectorAll( '.poll-option' );
		options.forEach( option => {
			const index = option.dataset.index;
			const count = votes[ index ] || 0;
			const percent = total > 0 ? Math.round( ( count / total ) * 100 ) : 0;

			const button = option.querySelector( '.poll-option-button' );
			if ( button ) {
				// Add or update percentage display
				let percentDisplay = button.querySelector( '.vote-percent' );
				if ( ! percentDisplay ) {
					percentDisplay = document.createElement( 'span' );
					percentDisplay.className = 'vote-percent';
					button.appendChild( percentDisplay );
				}
				percentDisplay.textContent = `${ percent }%`;

				// Add or update visual bar
				let progressBar = button.querySelector( '.vote-progress-bar' );
				if ( ! progressBar ) {
					progressBar = document.createElement( 'div' );
					progressBar.className = 'vote-progress-bar';
					button.appendChild( progressBar );
				}
				progressBar.style.width = `${ percent }%`;
			}
		} );
	}

	function displayVoteResults( pollId, percentages, voteCounts, totalVotes, forceShow = false ) {
		const pollModule = document.querySelector( `.poll-module[data-poll-id="${ pollId }"]` );
		if ( ! pollModule ) return;

		// console.log( 'Displaying vote results for poll:', pollId );
		// console.log( 'Percentages:', percentages );
		// console.log( 'Vote counts:', voteCounts );
		// console.log( 'Total votes:', totalVotes );
		// console.log( 'Force show:', forceShow );

		// Check if poll is closed
		const isClosed = pollModule.querySelector( '.status-closed' ) !== null;

		// Check if user has voted
		const hasVoted =
			pollModule.classList.contains( 'has-voted' ) ||
			pollModule.classList.contains( 'show-results' );

		// Determine if we should show results:
		// 1. Force show is true (for closed polls)
		// 2. Poll is closed (always show results)
		// 3. User has already voted (show results)
		const shouldShowResults = forceShow || isClosed || hasVoted;

		if ( ! shouldShowResults ) {
			// console.log( 'User has not voted yet and poll is open, hiding results' );
			return;
		}

		// console.log( 'Showing results - Poll closed:', isClosed, 'User voted:', hasVoted, 'Force show:', forceShow );

		// Update each option with percentage and vote count
		const options = pollModule.querySelectorAll( '.poll-option' );
		options.forEach( option => {
			const index = option.dataset.index;
			const percentage = percentages[ index ] || 0;
			const voteCount = voteCounts[ index ] || 0;

			// console.log( `Option ${ index }: ${ voteCount } votes, ${ percentage }%` );

			const button = option.querySelector( '.poll-option-button' );
			if ( button ) {
				// Show percentage display
				const percentDisplay = button.querySelector( '.vote-percent' );
				if ( percentDisplay ) {
					percentDisplay.textContent = `${ percentage }%`;
					percentDisplay.style.display = 'inline-block';

					// Calculate dynamic positioning for low percentages
					if ( percentage < 10 ) {
						// For low percentages, calculate position based on progress bar width
						const progressBar = button.querySelector( '.vote-progress-bar' );
						let offset = -32; // Default offset

						if ( progressBar && percentage > 0 ) {
							// Calculate the actual width of the colored progress bar
							const buttonWidth = button.offsetWidth;
							const progressWidth = ( percentage / 100 ) * buttonWidth;

							// Ensure minimum spacing of 8px between colored bar and percentage text
							const minSpacing = 8;
							offset = -( buttonWidth - progressWidth - minSpacing );

							// Ensure offset doesn't go too far left (minimum -40px)
							offset = Math.max( offset, -40 );
						}

						// Set the dynamic offset using CSS custom property
						button.style.setProperty( '--low-percentage-offset', `${ offset }px` );
						percentDisplay.classList.add( 'low-percentage' );
						button.classList.add( 'has-low-percentage' );

						// Also set the right position directly for immediate effect
						percentDisplay.style.right = `${ offset }px`;
						percentDisplay.style.color = '#ffffff';
						percentDisplay.style.textShadow = '0 0 2px rgba(0, 0, 0, 0.8)';
					} else if ( percentage === 0 ) {
						// For 0%, position further out with consistent spacing
						percentDisplay.style.right = '-40px';
						percentDisplay.style.color = '#ffffff';
						percentDisplay.style.textShadow = '0 0 2px rgba(0, 0, 0, 0.8)';
						percentDisplay.classList.add( 'low-percentage' );
						button.classList.add( 'has-low-percentage' );
					} else {
						// For normal percentages, position normally
						percentDisplay.style.right = '12px';
						percentDisplay.style.color = '#ffffff';
						percentDisplay.style.textShadow = 'none';
						percentDisplay.classList.remove( 'low-percentage' );
						button.classList.remove( 'has-low-percentage' );
					}
				}

				// Show progress bar with transition
				const progressBar = button.querySelector( '.vote-progress-bar' );
				if ( progressBar ) {
					// Reset width to 0 first to ensure transition works
					progressBar.style.width = '0%';
					progressBar.style.display = 'block';

					// Use setTimeout to trigger the transition after a brief delay
					setTimeout( () => {
						progressBar.style.width = `${ percentage }%`;
					}, 50 );
				}

				// Update individual vote count display
				const voteCountDisplay = option.querySelector( '.poll-totals' );
				if ( voteCountDisplay ) {
					const voteText = voteCount === 1 ? 'Vote' : 'Votes';
					voteCountDisplay.innerHTML = `<p>${ voteCount } ${ voteText }</p>`;
					voteCountDisplay.style.display = 'block';
				}
			}
		} );

		// Show total votes in the poll-status section
		const voteCountDisplay = pollModule.querySelector( '.poll-vote-count' );
		if ( voteCountDisplay ) {
			const totalElement = voteCountDisplay.querySelector( '.vote-total' );
			if ( totalElement ) {
				totalElement.textContent = totalVotes;
				totalElement.style.display = 'inline-block'; // Show vote count numbers
			}
			voteCountDisplay.style.display = 'block';
		}

		// Show custom logos
		const customLogos = pollModule.querySelector( '.poll-custom-logos' );
		if ( customLogos ) {
			customLogos.style.display = 'block';
			// Initialize custom logos when they become visible
			initializeShareButtons( pollModule );
		}
	}

	// Initialize polls and check IP vote status first
	pollModules.forEach( async module => {
		const pollId = module.dataset.pollId;
		// console.log( 'Initializing poll module:', pollId );

		// Increment poll view count on visit
		// jQuery.ajax( {
		// 	url: window.pollAjaxData?.ajaxurl || window.ajaxurl || '/wp-admin/admin-ajax.php',
		// 	type: 'GET',
		// 	data: {
		// 		action: 'increment_poll_view',
		// 		poll_id: pollId,
		// 	},
		// } );

		// Add visibility class to ensure polls are displayed
		module.classList.add( 'poll-visible' );

		// Hide poll option buttons initially
		const pollButtons = module.querySelectorAll( '.poll-option-button' );
		pollButtons.forEach( button => {
			button.style.display = 'none';
		} );

		// Make poll status visible initially (but hide vote counts for non-voters)
		const voteCountDisplay = module.querySelector( '.poll-vote-count' );
		if ( voteCountDisplay ) {
			// Show the poll status (POLL OPEN, etc.) but hide vote counts
			voteCountDisplay.style.display = 'block';

			// Hide vote count numbers for users who haven't voted
			const totalElement = voteCountDisplay.querySelector( '.vote-total' );
			if ( totalElement ) {
				totalElement.style.display = 'none';
			}
		}

		// FIXED: Use window.pollState.isOpen instead of looking for .status-closed element
		const isClosed = window.pollState && ! window.pollState.isOpen;

		// Also keep the old method as fallback
		const hasClosedElement = module.querySelector( '.status-closed' ) !== null;
		const isClosedFinal = isClosed || hasClosedElement;

		if ( isClosedFinal ) {
			// For closed polls, show actual results to everyone
			module.classList.add( 'show-results' );

			// Show poll option buttons for closed polls
			const pollButtons = module.querySelectorAll( '.poll-option-button' );
			pollButtons.forEach( button => {
				button.style.display = 'block';
			} );

			// Show vote count numbers for closed polls
			const voteCountDisplay = module.querySelector( '.poll-vote-count' );
			if ( voteCountDisplay ) {
				const totalElement = voteCountDisplay.querySelector( '.vote-total' );
				if ( totalElement ) {
					totalElement.style.display = 'inline-block';
				}
			}

			// FIXED: Force show results for closed polls regardless of user vote status
			loadPollResults( pollId, true );

			// Disable voting buttons for closed polls
			const buttons = module.querySelectorAll( '.poll-option-button' );
			buttons.forEach( btn => {
				btn.disabled = true;
			} );
		} else {
			// For open polls, check localStorage vote status
			const hasVoted = hasUserVotedOnPoll( pollId );

			if ( hasVoted ) {
				// User has voted - show results
				module.classList.add( 'has-voted' );

				// Show poll option buttons for users who have voted
				const pollButtons = module.querySelectorAll( '.poll-option-button' );
				pollButtons.forEach( button => {
					button.style.display = 'block';
					button.classList.add( 'voted' ); // Add voted class to all buttons
				} );

				// Disable voting buttons
				const buttons = module.querySelectorAll( '.poll-option-button' );
				buttons.forEach( btn => {
					btn.disabled = true;
				} );

				// Add light-voted class for light background polls
				if ( module.classList.contains( 'light-background' ) ) {
					const buttons = module.querySelectorAll( '.poll-option-button' );
					buttons.forEach( ( button, index ) => {
						button.classList.add( 'light-voted' );
					} );
				}

				// Show vote count numbers for users who have voted
				const voteCountDisplay = module.querySelector( '.poll-vote-count' );
				if ( voteCountDisplay ) {
					const totalElement = voteCountDisplay.querySelector( '.vote-total' );
					if ( totalElement ) {
						totalElement.style.display = 'inline-block';
					}
				}

				// Load actual results for previously voted polls
				loadPollResults( pollId, true );
			} else {
				// User has not voted - hide results, keep voting enabled
				// Ensure vote-related elements are hidden
				const options = module.querySelectorAll( '.poll-option' );
				options.forEach( option => {
					const progressBar = option.querySelector( '.vote-progress-bar' );
					const totals = option.querySelector( '.poll-totals' );
					const votePercent = option.querySelector( '.vote-percent' );

					if ( progressBar ) progressBar.style.display = 'none';
					if ( totals ) totals.style.display = 'none';
					if ( votePercent ) votePercent.style.display = 'none';
				} );

				// Hide total vote count for non-voters
				const voteCountDisplay = module.querySelector( '.poll-vote-count' );
				if ( voteCountDisplay ) {
					const totalElement = voteCountDisplay.querySelector( '.vote-total' );
					if ( totalElement ) {
						totalElement.style.display = 'none';
					}
				}
			}
		}
	} );

	// IP-based vote checking removed - now using simple localStorage

	// Function to load poll results from server
	async function loadPollResults( pollId, forceShow = false ) {
		const formData = new FormData();
		formData.append( 'action', 'get_poll_results' );
		formData.append( 'poll_id', pollId );

		// console.log( 'Loading poll results for poll:', pollId );

		jQuery.ajax( {
			url: window.pollAjaxData?.ajaxurl || window.ajaxurl || '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: formData,
			processData: false,
			contentType: false,
			success: function ( response ) {
				// console.log( 'Poll results response:', response );
				if ( response.success && response.data ) {
					displayVoteResults(
						pollId,
						response.data.percentages,
						response.data.vote_counts,
						response.data.total_votes,
						forceShow
					);

					// Mark voted options for multiple vote polls
					if ( response.data.user_voted_options ) {
						response.data.user_voted_options.forEach( optionIndex => {
							const button = document.querySelector(
								`[data-poll-id="${ pollId }"][data-option-index="${ optionIndex }"]`
							);
							if ( button ) {
								button.classList.add( 'voted' );
							}
						} );
					}
				}
			},
			error: function () {
				console.error( 'Failed to load poll results' );
			},
		} );
	}

	// Share buttons functionality - using event delegation for social icons
	document.addEventListener( 'click', function ( e ) {
		// Check if clicked on a social icon link
		const socialLink = e.target.closest( '.poll-custom-logos .social-icon' );
		if ( ! socialLink ) return;

		// Let the default link behavior handle the sharing
		// The href attributes are already properly set in the HTML
		// console.log( 'Social icon clicked:', socialLink );
	} );

	// Function to initialize social sharing buttons for a specific poll
	function initializeShareButtons( pollModule ) {
		const socialIcons = pollModule.querySelectorAll( '.poll-custom-logos .social-icon' );

		if ( socialIcons.length === 0 ) {
			// console.log( 'No social icons found in poll module:', pollModule );
			return;
		}

		// console.log( `Initializing ${ socialIcons.length } social icons for poll` );

		socialIcons.forEach( ( icon, index ) => {
			// Add visual feedback on hover
			icon.addEventListener( 'mouseenter', function () {
				this.style.transform = 'scale(1.1)';
				this.style.cursor = 'pointer';
			} );

			icon.addEventListener( 'mouseleave', function () {
				this.style.transform = 'scale(1)';
			} );

			// Add click cursor
			icon.style.cursor = 'pointer';

			// console.log( `Social icon ${ index + 1 } initialized:`, icon );
		} );
	}

	// Function to add mobile separators
	function addMobileSeparators( pollModule ) {
		// Only add separators if poll hasn't been voted on
		if (
			pollModule.classList.contains( 'has-voted' ) ||
			pollModule.classList.contains( 'show-results' )
		) {
			return;
		}

		const options = pollModule.querySelectorAll( '.poll-option' );
		const isLightBackground = pollModule.classList.contains( 'light-background' );

		options.forEach( ( option, index ) => {
			// Add separator after each option except the last one
			if ( index < options.length - 1 ) {
				const separator = document.createElement( 'div' );
				separator.className = 'poll-option-separator';
				separator.style.display = 'none'; // Hidden by default

				// Set color based on background
				if ( isLightBackground ) {
					separator.style.backgroundColor = '#d1d5db'; // Black for light background
				} else {
					separator.style.backgroundColor = ' rgba(255,255,255,.1)'; // White for dark background
				}

				// Show only on mobile
				if ( window.innerWidth <= 768 ) {
					separator.style.display = 'block';
					separator.style.height = '1px';
					separator.style.margin = '0.5rem 0';
				}

				option.after( separator );
			}
		} );
	}

	// Function to remove mobile separators
	function removeMobileSeparators( pollModule ) {
		const separators = pollModule.querySelectorAll( '.poll-option-separator' );
		separators.forEach( separator => separator.remove() );
	}

	// Function to update separators on window resize
	function updateSeparatorsOnResize() {
		pollModules.forEach( module => {
			const separators = module.querySelectorAll( '.poll-option-separator' );
			separators.forEach( separator => {
				if ( window.innerWidth <= 768 ) {
					separator.style.display = 'block';
				} else {
					separator.style.display = 'none';
				}
			} );
		} );
	}

	// Initialize separators for existing polls
	pollModules.forEach( module => {
		addMobileSeparators( module );
	} );

	// Listen for window resize
	window.addEventListener( 'resize', updateSeparatorsOnResize );

	// Function to refresh poll results across all devices
	async function refreshPollResults( pollId ) {
		const pollModule = document.querySelector( `.poll-module[data-poll-id="${ pollId }"]` );
		if ( ! pollModule ) return;

		// Load fresh results from server
		await loadPollResults( pollId, true );

		// Also refresh for other devices by triggering a custom event
		window.dispatchEvent(
			new CustomEvent( 'pollResultsUpdated', {
				detail: { pollId: pollId },
			} )
		);
	}

	// Listen for poll result updates from other devices
	window.addEventListener( 'pollResultsUpdated', async function ( event ) {
		const pollId = event.detail.pollId;
		// Refresh results when another device updates them
		await loadPollResults( pollId, true );
	} );

	// Set up periodic refresh for active polls (every 5 seconds)
	// Only refresh for users who have already voted or for closed polls
	// setInterval( async function () {
	// 	for ( const module of pollModules ) {
	// 		const pollId = module.dataset.pollId;
	// 		// Only refresh if user has voted or poll is closed
	// 		if (
	// 			module.classList.contains( 'has-voted' ) ||
	// 			module.classList.contains( 'show-results' )
	// 		) {
	// 			await refreshPollResults( pollId );
	// 		}
	// 	}
	// }, 5000 ); // 5 seconds

	// Initialize custom logos for existing polls
	pollModules.forEach( module => {
		initializeShareButtons( module );
	} );

	// Global click handler for poll options to show error message when already voted
	document.addEventListener( 'click', function ( e ) {
		// Check if clicked on a poll option
		const pollOption = e.target.closest( '.poll-option' );
		if ( ! pollOption ) return;

		// console.log('Poll option clicked:', e.target);
		// console.log('Is progress bar:', e.target.closest( '.vote-progress-bar' ));
		// console.log('Is button:', e.target.closest( 'button' ));

		// Always allow progress bar clicks, but don't trigger for other button clicks
		if ( e.target.closest( '.vote-progress-bar' ) ) {
			// console.log('Progress bar clicked - continuing to show error message');
		} else if ( e.target.closest( 'button' ) ) {
			// console.log('Regular button clicked - not showing error message');
			return;
		}

		const pollModule = pollOption.closest( '.poll-module' );
		const pollId = pollModule.dataset.pollId;

		// Check if user has already voted using simple localStorage check
		const hasVoted = hasUserVotedOnPoll( pollId );

		// If user has already voted, show error message
		if ( hasVoted ) {
			// Remove any existing messages
			const existingMessages = pollModule.querySelectorAll( '.poll-message' );
			existingMessages.forEach( msg => msg.remove() );

			const errorMessageDiv = document.createElement( 'div' );
			errorMessageDiv.className = 'poll-message error';
			errorMessageDiv.innerHTML = `
				<div class="error-message">
					<p style="margin: 0;">You have already voted on this poll. You can only vote once.</p>
				</div>`;

			// Insert message after the poll options
			const pollOptions = pollModule.querySelector( '.poll-options' );
			if ( pollOptions ) {
				pollOptions.before( errorMessageDiv );
			}
		}
	} );

	// Specific event listener for progress bar clicks - use capture to run before button onclick
	document.addEventListener(
		'click',
		function ( e ) {
			// console.log('=== PROGRESS BAR CLICK DEBUG ===');
			// console.log('Event target:', e.target);
			// console.log('Event currentTarget:', e.currentTarget);
			// console.log('Event phase:', e.eventPhase);

			// Check if clicked on a progress bar
			const progressBar = e.target.closest( '.vote-progress-bar' );
			// console.log('Progress bar found:', progressBar);

			if ( ! progressBar ) {
				// console.log('No progress bar found, returning');
				return;
			}

			// Prevent the button's onclick from firing
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			// console.log('Progress bar clicked directly:', progressBar);

			const pollOption = progressBar.closest( '.poll-option' );
			if ( ! pollOption ) return;

			const pollModule = pollOption.closest( '.poll-module' );
			const pollId = pollModule.dataset.pollId;

			// Check if user has already voted using simple localStorage check
			const hasVoted = hasUserVotedOnPoll( pollId );

			// If user has already voted, show error message
			if ( hasVoted ) {
				// console.log('User has voted, showing error message for progress bar click');
				// Remove any existing messages
				const existingMessages = pollModule.querySelectorAll( '.poll-message' );
				existingMessages.forEach( msg => msg.remove() );

				const errorMessageDiv = document.createElement( 'div' );
				errorMessageDiv.className = 'poll-message error';
				errorMessageDiv.innerHTML = `
				<div class="error-message">
					<p style="margin: 0;">You have already voted on this poll. You can only vote once.</p>
				</div>`;

				// Insert message after the poll options
				const pollOptions = pollModule.querySelector( '.poll-options' );
				if ( pollOptions ) {
					pollOptions.before( errorMessageDiv );
				}
			}
		},
		true
	); // Use capture phase to run before button onclick

	// Handle option selection for multiple vote polls
	document.querySelectorAll( '.poll-option' ).forEach( optionEl => {
		const button = optionEl.querySelector( '.poll-option-button' );
		if ( ! button ) return;

		const pollId = button.dataset.pollId;
		const pollModule = optionEl.closest( '.poll-module' );
		const isMultipleVote = pollModule.querySelector( '.poll-submit-btn' ) !== null;
		const progressBar = optionEl.querySelector( '.vote-progress-bar' );
		const totals = optionEl.querySelector( '.poll-totals' );

		// Check if user has already voted using simple localStorage check
		const hasVoted = hasUserVotedOnPoll( pollId );

		if ( hasVoted ) {
			// User already voted: show results, disable interactions
			progressBar && ( progressBar.style.display = 'block' );
			totals && ( totals.style.display = 'block' );
			optionEl.classList.remove( 'selected-option' );
			// Keep options clickable for error message

			// Disable button
			button.disabled = true;
			button.classList.add( 'voted' );

			// Handle button visibility for voted polls
			const pollModule = optionEl.closest( '.poll-module' );
			const submitBtn = pollModule.querySelector( '.poll-submit-btn' );

			if ( submitBtn ) {
				submitBtn.style.display = 'none';
			}
		} else {
			// Hide results initially for new users - clean state for new polls
			progressBar && ( progressBar.style.display = 'none' );
			totals && ( totals.style.display = 'none' );

			// Ensure all vote-related elements are hidden for new polls
			const votePercent = button.querySelector( '.vote-percent' );
			if ( votePercent ) {
				votePercent.style.display = 'none';
			}

			// Make entire option clickable for multiple vote polls
			if ( isMultipleVote ) {
				// For multiple vote polls, handle selection without immediate submission
				optionEl.addEventListener( 'click', function ( e ) {
					// Don't trigger if clicking on the button itself
					if ( e.target.closest( 'button' ) ) return;

					// Toggle selection
					optionEl.classList.toggle( 'selected-option' );

					// Update submit button state
					const submitBtn = pollModule.querySelector( '.submit-vote-btn' );
					const selectedOptions = pollModule.querySelectorAll(
						'.poll-option.selected-option'
					);

					if ( submitBtn ) {
						if ( selectedOptions.length > 0 ) {
							submitBtn.disabled = false;
							submitBtn.textContent = `Submit Vote${
								selectedOptions.length > 1 ? 's' : ''
							} (${ selectedOptions.length })`;
						} else {
							submitBtn.disabled = true;
							submitBtn.textContent = 'Submit Vote';
						}
					}
				} );
			} else {
				// For single vote polls, handle immediate submission
				optionEl.addEventListener( 'click', function ( e ) {
					// Don't trigger if clicking on a button itself
					if ( e.target.closest( 'button' ) ) return;

					const optionIndex = parseInt( optionEl.dataset.index );
					const pollId = pollModule.dataset.pollId;

					// Check if user already voted for this poll
					const votedPolls = JSON.parse( localStorage.getItem( 'votedPolls' ) || '{}' );
					if ( votedPolls[ pollId ] ) {
						//alert( 'You have already voted in this poll.' );
						return;
					}

					// Submit the vote
					if ( typeof window.storePollResponse === 'function' ) {
						window.storePollResponse( pollId, optionIndex );

						// Mark this poll as voted
						votedPolls[ pollId ] = true;
						localStorage.setItem( 'votedPolls', JSON.stringify( votedPolls ) );
					}
				} );
			}
		}

		// Show vote header state
		const voteOpen = document.querySelector(
			`.poll-vote-count[data-poll-id="${ pollId }"] .total-votes-poll-open`
		);
		const voteAfter = document.querySelector(
			`.poll-vote-count[data-poll-id="${ pollId }"] .total-votes-poll-after-vote`
		);

		if ( hasVoted ) {
			voteOpen && ( voteOpen.style.display = 'none' );
			voteAfter && ( voteAfter.style.display = 'block' );
		}
	} );

	// Function to open Dotdigital modal
	function openDotdigitalModal( pollId ) {
		const modal = document.getElementById( `dotdigital-modal-${ pollId }` );
		if ( modal ) {
			modal.style.display = 'block';
			document.body.style.overflow = 'hidden'; // Prevent background scrolling
			// console.log('Opening Dotdigital modal for poll:', pollId);
		} else {
			// console.log('Dotdigital modal not found for poll:', pollId);
		}
	}

	// Function to close Dotdigital modal
	function closeDotdigitalModal( pollId ) {
		const modal = document.getElementById( `dotdigital-modal-${ pollId }` );
		if ( modal ) {
			modal.style.display = 'none';
			document.body.style.overflow = 'auto'; // Restore scrolling
		}
	}

	// Close modal when clicking outside
	document.addEventListener( 'click', function ( e ) {
		if ( e.target.classList.contains( 'dotdigital-modal-overlay' ) ) {
			const modal = e.target.closest( '.dotdigital-modal' );
			if ( modal ) {
				const pollId = modal.id.replace( 'dotdigital-modal-', '' );
				closeDotdigitalModal( pollId );
			}
		}
	} );

	// Close modal with Escape key
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) {
			const openModal = document.querySelector( '.dotdigital-modal[style*="block"]' );
			if ( openModal ) {
				const pollId = openModal.id.replace( 'dotdigital-modal-', '' );
				closeDotdigitalModal( pollId );
			}
		}
	} );

	// Handle submit button clicks using event delegation
	document.addEventListener( 'click', function ( e ) {
		if ( e.target.classList.contains( 'submit-vote-btn' ) ) {
			e.preventDefault();
			// console.log( 'Submit button clicked!' ); // Debug

			const submitBtn = e.target;
			const pollModule = submitBtn.closest( '.poll-module' );
			const pollId = pollModule.dataset.pollId;

			// Check if user has already voted using simple localStorage check
			const hasVoted = hasUserVotedOnPoll( pollId );

			// If user has already voted, show error message
			if ( hasVoted ) {
				// Remove any existing messages
				const existingMessages = pollModule.querySelectorAll( '.poll-message' );
				existingMessages.forEach( msg => msg.remove() );

				const errorMessageDiv = document.createElement( 'div' );
				errorMessageDiv.className = 'poll-message error';
				errorMessageDiv.innerHTML = `
					<div class="error-message">
						<p style="margin: 0;">You have already voted on this poll. You can only vote once.</p>
					</div>`;

				// Insert message after the poll options
				const pollOptions = pollModule.querySelector( '.poll-options' );
				if ( pollOptions ) {
					pollOptions.before( errorMessageDiv );
				}
				return;
			}

			const selectedOptions = Array.from(
				pollModule.querySelectorAll( '.poll-option.selected-option' )
			);

			if ( selectedOptions.length === 0 ) {
				alert( 'Please select at least one option to vote.' );
				return;
			}

			// Prevent double-clicking
			if ( submitBtn.disabled ) {
				return;
			}

			// Disable submit to prevent double voting
			submitBtn.disabled = true;
			submitBtn.textContent = 'Submitting...';

			let completedVotes = 0;
			let totalVotes = selectedOptions.length;
			let allVotesSuccessful = true;

			selectedOptions.forEach( ( optionEl, index ) => {
				const btn = optionEl.querySelector( '.poll-option-button' );
				const optionIndex = parseInt( btn.dataset.optionIndex );

				// Disable the button while voting
				btn.disabled = true;
				btn.classList.add( 'voting-in-progress' );

				// Send AJAX vote for each selected option
				const formData = new FormData();
				formData.append( 'action', 'submit_poll_response' );
				formData.append( 'poll_id', pollId );
				formData.append( 'option_index', optionIndex );

				// Add nonce if available
				if ( typeof ajax_object !== 'undefined' && ajax_object.nonce ) {
					formData.append( 'nonce', ajax_object.nonce );
				}

				// Log the request data for debugging
				// console.log( 'Submitting vote:', {
				// 	pollId: pollId,
				// 	optionIndex: optionIndex,
				// 	ajaxUrl:
				// 		window.pollAjaxData?.ajaxurl ||
				// 		window.ajaxurl ||
				// 		'/wp-admin/admin-ajax.php',
				// 	hasNonce: typeof ajax_object !== 'undefined' && ajax_object.nonce,
				// } );

				jQuery.ajax( {
					url:
						window.pollAjaxData?.ajaxurl ||
						window.ajaxurl ||
						'/wp-admin/admin-ajax.php',
					type: 'POST',
					data: formData,
					processData: false,
					contentType: false,
					timeout: 30000, // 30 second timeout
					success: function ( response ) {
						// console.log( 'Vote response for option', optionIndex, ':', response );
						completedVotes++;

						if ( ! response.success ) {
							console.error( 'Vote failed for option', optionIndex, ':', response );
							allVotesSuccessful = false;
						}

						// When all votes are done
						if ( completedVotes === totalVotes ) {
							// Re-enable submit button
							submitBtn.disabled = false;
							submitBtn.textContent = 'Submit Vote';

							if ( allVotesSuccessful ) {
								// Show success message
								const messageDiv = document.createElement( 'div' );
								messageDiv.className = 'poll-message success';
								messageDiv.innerHTML = `
									<div class="success-message">
										<p style="margin: 0;">Thank you for voting!</p>
									</div>`;

								const pollOptions = pollModule.querySelector( '.poll-options' );
								if ( pollOptions ) {
									pollOptions.before( messageDiv );
								}

								// Disable all options
								pollModule.querySelectorAll( '.poll-option' ).forEach( opt => {
									opt.classList.remove( 'selected-option' );
									// Keep options clickable for error message

									// Disable the button
									const button = opt.querySelector( '.poll-option-button' );
									if ( button ) {
										button.disabled = true;
										button.classList.remove( 'voting-in-progress' );
										button.classList.add( 'voted' );
									}
								} );

								// Show results
								pollModule.classList.add( 'has-voted' );

								// Store voted options in localStorage
								try {
									const votedOptions = selectedOptions.map( opt =>
										parseInt(
											opt.querySelector( '.poll-option-button' ).dataset
												.optionIndex
										)
									);
									localStorage.setItem(
										`poll_voted_options_${ pollId }`,
										JSON.stringify( votedOptions )
									);
								} catch ( e ) {
									console.error( 'Could not store vote in localStorage', e );
								}

								// Hide submit button for multiple vote polls
								const submitBtnContainer =
									pollModule.querySelector( '.poll-submit-btn' );

								if ( submitBtnContainer ) {
									submitBtnContainer.style.display = 'none';
								}

								// Load and display results with vote counts
								loadPollResults( pollId, true );

								// Show poll option buttons after voting
								const allButtons =
									pollModule.querySelectorAll( '.poll-option-button' );
								// console.log(
								// 	'Showing poll option buttons after voting (multiple vote):',
								// 	allButtons.length
								// );
								allButtons.forEach( ( button, index ) => {
									button.style.display = 'block';
									button.classList.add( 'voted' );
									// console.log(
									// 	`Showed and added voted class to button ${ index }`
									// );
								} );

								// Add turquoise styling for light background polls after voting
								if ( pollModule.classList.contains( 'light-background' ) ) {
									// console.log(
									// 	'Adding light-voted class to poll option buttons for light background (multiple vote)'
									// );
									const buttons =
										pollModule.querySelectorAll( '.poll-option-button' );
									// console.log( 'Found buttons:', buttons.length );
									buttons.forEach( ( button, index ) => {
										button.classList.add( 'light-voted' );
										// console.log(
										// 	`Added light-voted class to button ${ index }`
										// );
									} );
								} else {
									// console.log(
									// 	'Poll is not light background, skipping light-voted class (multiple vote)'
									// );
								}

								// Trigger refresh for other devices
								refreshPollResults( pollId ).catch( console.error );

								// Open Dotdigital modal if embed code exists
								const dotdigitalModal = document.getElementById(
									`dotdigital-modal-${ pollId }`
								);
								if ( dotdigitalModal ) {
									setTimeout( () => {
										openDotdigitalModal( pollId );
									}, 3000 ); // Open modal after 3 second
								}
							} else {
								// Show error message
								const messageDiv = document.createElement( 'div' );
								messageDiv.className = 'poll-message error';
								messageDiv.innerHTML = `
									<div class="error-message">
										<p style="margin: 0;">Some votes failed to submit. Please try again.</p>
									</div>`;

								const pollOptions = pollModule.querySelector( '.poll-options' );
								if ( pollOptions ) {
									pollOptions.before( messageDiv );
								}

								// Re-enable selected options for retry
								selectedOptions.forEach( optionEl => {
									const btn = optionEl.querySelector( '.poll-option-button' );
									btn.disabled = false;
									btn.classList.remove( 'voting-in-progress' );
								} );
							}
						}
					},
					error: function ( xhr, status, error ) {
						console.error( 'AJAX Error for option', optionIndex, ':', {
							xhr,
							status,
							error,
						} );
						completedVotes++;
						allVotesSuccessful = false;

						// Re-enable the button on error
						const btn = optionEl.querySelector( '.poll-option-button' );
						btn.disabled = false;
						btn.classList.remove( 'voting-in-progress' );

						// When all votes are done
						if ( completedVotes === totalVotes ) {
							// Re-enable submit button
							submitBtn.disabled = false;
							submitBtn.textContent = 'Submit Vote';

							// Show detailed error message
							let errorMessage = 'Error submitting votes. Please try again.';
							if ( status === 'timeout' ) {
								errorMessage =
									'Request timed out. Please check your connection and try again.';
							} else if ( status === 'error' ) {
								errorMessage =
									'Network error. Please check your connection and try again.';
							} else if ( xhr.status === 403 ) {
								errorMessage =
									'Access denied. You may have already voted or the poll is closed.';
							} else if ( xhr.status === 500 ) {
								errorMessage = 'Server error. Please try again later.';
							}

							const messageDiv = document.createElement( 'div' );
							messageDiv.className = 'poll-message error';
							messageDiv.innerHTML = `
								<div class="error-message">
									<p style="margin: 0;">${ errorMessage }</p>
									<p style="margin: 5px 0 0 0; font-size: 12px;">Status: ${ status }, Code: ${ xhr.status }</p>
								</div>`;

							const pollOptions = pollModule.querySelector( '.poll-options' );
							if ( pollOptions ) {
								pollOptions.before( messageDiv );
							}
						}
					},
				} );
			} );
		}
	} );

	// Function to recalculate low percentage positioning for all polls
	function recalculateLowPercentagePositions() {
		pollModules.forEach( module => {
			const options = module.querySelectorAll( '.poll-option' );
			options.forEach( option => {
				const button = option.querySelector( '.poll-option-button' );
				const percentDisplay = button?.querySelector( '.vote-percent.low-percentage' );

				if (
					button &&
					percentDisplay &&
					button.classList.contains( 'has-low-percentage' )
				) {
					// Get the current percentage from the text
					const percentText = percentDisplay.textContent;
					const percentage = parseFloat( percentText );

					if ( percentage < 10 && percentage > 0 ) {
						// Recalculate position based on new button width
						const buttonWidth = button.offsetWidth;
						const progressWidth = ( percentage / 100 ) * buttonWidth;

						// Ensure minimum spacing of 8px between colored bar and percentage text
						const minSpacing = 8;
						let offset = -( buttonWidth - progressWidth - minSpacing );

						// Ensure offset doesn't go too far left (minimum -40px)
						offset = Math.max( offset, -40 );

						// Update the positioning
						button.style.setProperty( '--low-percentage-offset', `${ offset }px` );
						percentDisplay.style.right = `${ offset }px`;
					}
				}
			} );
		} );
	}

	// Listen for window resize to recalculate positions
	window.addEventListener( 'resize', debounce( recalculateLowPercentagePositions, 250 ) );

	// Debounce function to limit resize event calls
	function debounce( func, wait ) {
		let timeout;
		return function executedFunction( ...args ) {
			const later = () => {
				clearTimeout( timeout );
				func( ...args );
			};
			clearTimeout( timeout );
			timeout = setTimeout( later, wait );
		};
	}
} );

// Close modal when clicking outside
document.addEventListener( 'click', function ( e ) {
	if ( e.target.classList.contains( 'dotdigital-modal-overlay' ) ) {
		const modal = e.target.closest( '.dotdigital-modal' );
		if ( modal ) {
			const pollId = modal.id.replace( 'dotdigital-modal-', '' );
			closeDotdigitalModal( pollId );
		}
	}
} );

// Close modal with Escape key
document.addEventListener( 'keydown', function ( e ) {
	if ( e.key === 'Escape' ) {
		const openModal = document.querySelector( '.dotdigital-modal[style*="block"]' );
		if ( openModal ) {
			const pollId = openModal.id.replace( 'dotdigital-modal-', '' );
			closeDotdigitalModal( pollId );
		}
	}
} );

// const viewBtn = document.querySelector( '.poll-view-form-btn' );
// const modal = document.querySelector( '.dotdigital-modal' );
// const pollModule = document.querySelector( '.poll-module' );

// if ( viewBtn ) {
// 	//  Check first: if pollModule already has "has-voted"
// 	if ( pollModule && pollModule.classList.contains( 'has-voted' ) ) {
// 		viewBtn.style.display = 'block';
// 	} else {
// 		// Otherwise keep it hidden
// 		viewBtn.style.display = 'none';
// 	}

// 	//  Case 2: If modal opens at least once
// 	if ( modal ) {
// 		const observer = new MutationObserver( () => {
// 			const isVisible = window.getComputedStyle( modal ).display === 'block';
// 			if ( isVisible ) {
// 				viewBtn.style.display = 'block';
// 				observer.disconnect(); // stop observing, button stays forever
// 			}
// 		} );

// 		observer.observe( modal, { attributes: true, attributeFilter: [ 'style' ] } );
// 	}

// 	// Reopen modal when button is clicked
// 	viewBtn.addEventListener( 'click', () => {
// 		if ( modal ) {
// 			modal.style.display = 'block';
// 			modal.classList.add( 'opened' );
// 		}
// 	} );
// }
const viewBtn = document.querySelector( '.poll-view-form-btn' );
const modal = document.querySelector( '.dotdigital-modal' );
const pollModule = document.querySelector( '.poll-module' );

if ( viewBtn && modal ) {
	// --- Check saved state in localStorage ---
	if ( localStorage.getItem( 'pollHasVoted' ) === 'true' ) {
		viewBtn.style.display = 'block'; // always show if already voted
	} else if ( pollModule && pollModule.classList.contains( 'has-voted' ) ) {
		// Save to localStorage if this session just voted
		localStorage.setItem( 'pollHasVoted', 'true' );
		viewBtn.style.display = 'block';
	} else {
		viewBtn.style.display = 'none';
	}

	// --- Functions ---
	function openModal() {
		modal.style.display = 'block';
		modal.classList.add( 'opened' );
		document.body.style.overflow = 'hidden'; // remove scrollbar

		// Once opened, keep button forever visible
		localStorage.setItem( 'pollHasVoted', 'true' );
		viewBtn.style.display = 'block';
	}

	function closeModal() {
		modal.style.display = 'none';
		modal.classList.remove( 'opened' );
		document.body.style.overflow = ''; // restore scrollbar
	}

	// Open modal when view button is clicked
	viewBtn.addEventListener( 'click', openModal );

	// Close modal when clicking outside (on backdrop)
	window.addEventListener( 'click', e => {
		if ( modal.classList.contains( 'opened' ) && e.target === modal ) {
			closeModal();
		}
	} );

	// Close modal on ESC key
	window.addEventListener( 'keydown', e => {
		if ( e.key === 'Escape' && modal.classList.contains( 'opened' ) ) {
			closeModal();
		}
	} );

	// Detect if modal opens automatically
	const observer = new MutationObserver( () => {
		const isVisible = window.getComputedStyle( modal ).display === 'block';
		if ( isVisible && ! modal.classList.contains( 'opened' ) ) {
			openModal();
		} else if ( ! isVisible && modal.classList.contains( 'opened' ) ) {
			closeModal();
		}
	} );
	observer.observe( modal, { attributes: true, attributeFilter: [ 'style' ] } );
}
